export enum ACTION {
  VIEW = "view",
  DOWNLOAD = "download",
}
